import React from "react";
import { useSelector } from "react-redux";
import style from "./measurementStatus.module.scss";
import { Button } from "../../../primary";
import { MeasurementLoader } from "./measurementLoader";

export const MeasurementStatus = ({ showMeasurementModal, pendingRetires, maxPendingRetries, disabled }) => {
  const { measurementData } = useSelector((state) => state.patient.newWoundMeasurements) || { loading: false, measurementData: null };
  const status = measurementData?.status;

  const errorStatus = status === "error" || status === "no_measurements";

  return (
    <div className="col pl-4">
      <div>
        <div className="mb-3">
          {status === "pending" && !measurementData?.measurementRetry && (
            <>
              <MeasurementLoader pendingRetires={pendingRetires} maxPendingRetries={maxPendingRetries} />
            </>
          )}

          {errorStatus && (
            <p className={`${style.dim_man_p}`}>
              Enter{" "}
              <Button
                type="button"
                value="Dimensions"
                id="autoMeasurement"
                classes={{ className: `btn pt-2 ${style.dim_man_btn}` }}
                onClick={() => showMeasurementModal("Dimensions")}
                disabled={disabled}
              />{" "}
              manually.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
